const CLOSED_LOST = '0.0';
const CLOSED_WON = '1.0';
export const getProjectedTotalMessage = (probability, hasBoardCardV2 = false) => {
  switch (probability) {
    case CLOSED_LOST:
      return 'crmObjectBoard.deals.projectedTotal.closedLost';
    case CLOSED_WON:
      return 'crmObjectBoard.deals.projectedTotal.closedWon';
    default:
      return hasBoardCardV2 ? 'crmObjectBoard.deals.projectedTotal.defaultText' : 'crmObjectBoard.deals.projectedTotal.default';
  }
};
export const getProjectedTotalTooltipMessage = probability => {
  switch (probability) {
    case CLOSED_LOST:
      return 'crmObjectBoard.deals.projectedTotal.closedLostLabel';
    case CLOSED_WON:
      return 'crmObjectBoard.deals.projectedTotal.closedWonLabel';
    default:
      return 'crmObjectBoard.deals.weightedTotal.defaultLabel';
  }
};